
// src/actions/sessions.js

import api from './gamba-api'
import AccessToken from '../actions/access-token'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const LOGIN = "LOGIN"
export const LOGIN_REQUESTED = "LOGIN_REQUESTED"
export const LOGIN_COMPLETED = "LOGIN_COMPLETED"
export const LOGIN_FAILED = "LOGIN_FAILED"
export const CLEAR_LOGIN_STATUS = "CLEAR_LOGIN_STATUS"

export function loginRequested() {
  return {
    type: LOGIN_REQUESTED
  }
}

export function login(email, opts = {}) {
  const {
    password,
    passcode,
    new_password,
    password_confirmation
  } = opts

  return function(dispatch) {
    dispatch(loginRequested())
    return api.post(`/sessions`, { email, password, new_password, password_confirmation, passcode })
        .then((results)=> {
          if (results.access_token)
            AccessToken.set(results.access_token, ()=> dispatch(loginCompleted(results)))
          else
            dispatch(loginCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(loginFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function loginCompleted(results) {
  return {
    type: LOGIN_COMPLETED,
    results,
  }
}

export function loginFailed(error) {
  return {
    type: LOGIN_FAILED,
    error,
  }
}

export function clearLoginStatus() {
  return {
    type: CLEAR_LOGIN_STATUS,
  }
}

export const LOGOUT = "LOGOUT"
export const LOGOUT_REQUESTED = "LOGOUT_REQUESTED"
export const LOGOUT_COMPLETED = "LOGOUT_COMPLETED"
export const LOGOUT_FAILED = "LOGOUT_FAILED"

export function logoutRequested() {
  return {
    type: LOGOUT_REQUESTED,
  }
}

export function logout(all_logout) {
  return function(dispatch) {
    dispatch(logoutRequested())
    return api.delete(`/sessions`, { all_logout })
        .then((results)=> {
          AccessToken.clear()
          dispatch(logoutCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(logoutFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function logoutCompleted(results) {
  return {
    type: LOGOUT_COMPLETED,
    results,
  }
}

export function logoutFailed(error) {
  return {
    type: LOGOUT_FAILED,
    error,
  }
}

export const CHECK_LOGIN_STATUS = "CHECK_LOGIN_STATUS"
export const CHECK_LOGIN_STATUS_REQUESTED = "CHECK_LOGIN_STATUS_REQUESTED"
export const CHECK_LOGIN_STATUS_COMPLETED = "CHECK_LOGIN_STATUS_COMPLETED"

export function checkLoginStatusRequested() {
  return {
    type: CHECK_LOGIN_STATUS_REQUESTED
  }
}

export function checkLoginStatusCompleted(access_token) {
  return {
    type: CHECK_LOGIN_STATUS_COMPLETED,
    access_token,
  }
}

export function checkLoginStatus() {
  return function(dispatch) {
    dispatch(checkLoginStatusRequested())
    AccessToken.get((token)=> dispatch(checkLoginStatusCompleted(token)))
  }
}



// WEBPACK FOOTER //
// ./src/actions/sessions.js